import React from "react";
import Routing from "./routing/Routing";
import { LanguageProvider } from "./routes/LanguageContext";

const App = () => {
  return (
    <LanguageProvider>
      <Routing />
    </LanguageProvider>
  );
};

export default App;
